module.exports = __webpack_public_path__ + "img/digiwatch.jpg_w545.5c0de43a.jpg";